import { lazy } from "react";
import MBGNotifPrice from "../page/mbg_dashboard/notif_price/MBGNotifPrice";

// route //////////////
export const mbgReqRoute = { path: `/request`, name: "mbg.menu.request", icon: "request_quote_icon" };
export const mbgReqViewRoute = { path: `${mbgReqRoute.path}/detail`, name: "mbg.request.detail" };

export const mbgFundingRoute = { path: `/bill`, name: "mbg.menu.funding", icon: "request_quote_icon" };
export const mbgFundingViewRoute = { path: `${mbgFundingRoute.path}/detail`, name: "mbg.funding.detail" };

export const mbgKitchenRoute = { path: "/kitchen", name: "mbg.menu.kitchen", icon: "kitchen_icon" };
export const mbgKitchenCreateRoute = { path: `${mbgKitchenRoute.path}/create`, name: "mbg.kitchen.add" };
export const mbgKitchenEditRoute = { path: `${mbgKitchenRoute.path}/edit`, name: "mbg.kitchen.edit" };

export const mbgSupplierRoute = { path: "/supplier", name: "mbg.menu.supplier", icon: "business_icon" };
export const mbgSupplierCreateRoute = { path: `${mbgSupplierRoute.path}/create`, name: "mbg.supplier.add" };
export const mbgSupplierEditRoute = { path: `${mbgSupplierRoute.path}/edit`, name: "mbg.supplier.edit" };
export const mbgSupplierSKURoute = { path: `${mbgSupplierRoute.path}/sku`, name: "mbg.supplier.sku" };

export const mbgProjectRoute = { path: "/project", name: "mbg.menu.project", icon: "task" };
export const mbgProjectCreateRoute = { path: `${mbgProjectRoute.path}/create`, name: "mbg.project.add" };
export const mbgProjectEditRoute = { path: `${mbgProjectRoute.path}/edit`, name: "mbg.project.edit" };
export const mbgProjectViewRoute = { path: `${mbgProjectRoute.path}/view`, name: "mbg.project.view" };

export const mbgProjectKitchenRoute = { path: `${mbgProjectRoute.path}/kitchen`, name: "mbg.project.kitchen" };
export const mbgProjectKitchenCreateRoute = { path: `${mbgProjectRoute.path}/create_kitchen`, name: "mbg.project.add_kitchen" };
export const mbgProjectKitchenEditRoute = { path: `${mbgProjectRoute.path}/edit_kitchen`, name: "mbg.project.edit_kitchen" };

export const mbgNotifPriceRoute = { path: `/notif_price`, name: "mbg.menu.notif_price", icon: 'price_change' };

// component
const MBG = lazy(() => import("../page/mbg_dashboard/MBGDashboard"));
const MBGKitchen = lazy(() => import("../page/mbg_dashboard/kitchen/MBGKitchen"));
const MBGKitchenForm = lazy(() => import("../page/mbg_dashboard/kitchen/form/MBGKitchenForm"));
const MBGProject = lazy(() => import("../page/mbg_dashboard/project/MBGProject"));
const MBGProjectView = lazy(() => import("../page/mbg_dashboard/project/MBGProjectDetail"));
const MBGProjectForm = lazy(() => import("../page/mbg_dashboard/project/form/MBGProjectForm"));
const MBGProjectKitchen = lazy(() => import("../page/mbg_dashboard/project/kitchen/MBGProjectKitchen"));
const MBGProjectKitchenForm = lazy(() => import("../page/mbg_dashboard/project/kitchen/form/MBGProjectKitchenForm"));
const MBGRequest = lazy(() => import("../page/mbg_dashboard/request/MBGRequest"));
const MBGRequestView = lazy(() => import("../page/mbg_dashboard/request/view/MBGRequestView"));
const MBGFunding = lazy(() => import("../page/mbg_dashboard/funding/MBGFunding"));
const MBGFundingView = lazy(() => import("../page/mbg_dashboard/funding/view/MBGFundingView"));
const MBGSupplier = lazy(() => import("../page/mbg_dashboard/supplier/MBGSupplier"));
const MBGSupplierSKU = lazy(() => import("../page/mbg_dashboard/supplier/sku/MBGSupplierSKU"));
const MBGSupplierFrom = lazy(() => import("../page/mbg_dashboard/supplier/form/MBGSupplierForm"));
const mbgNotifPrice = lazy(() => import("../page/mbg_dashboard/notif_price/MBGNotifPrice"));

export const mbgListRoutes = [
    mbgKitchenRoute, mbgSupplierRoute, mbgReqRoute,
    mbgProjectRoute, mbgFundingRoute, mbgNotifPriceRoute
]
export const mbgMutationRoutes = [
    mbgReqViewRoute, mbgFundingViewRoute,
    mbgKitchenCreateRoute, mbgKitchenEditRoute,
    mbgSupplierCreateRoute, mbgSupplierEditRoute, mbgSupplierSKURoute,
    mbgProjectCreateRoute, mbgProjectEditRoute, mbgProjectViewRoute,
    mbgProjectKitchenRoute, mbgProjectKitchenCreateRoute, mbgProjectKitchenEditRoute,
]

export const mbgRoutes = [{
    element: <MBG />,
    children: [
        { ...mbgKitchenRoute, element: <MBGKitchen /> },
        { ...mbgKitchenCreateRoute, element: <MBGKitchenForm /> },
        { ...mbgKitchenEditRoute, element: <MBGKitchenForm /> },
        { ...mbgProjectRoute, element: <MBGProject /> },
        { ...mbgProjectViewRoute, element: <MBGProjectView /> },
        { ...mbgProjectCreateRoute, element: <MBGProjectForm /> },
        { ...mbgProjectEditRoute, element: <MBGProjectForm /> },
        { ...mbgProjectKitchenRoute, element: <MBGProjectKitchen /> },
        { ...mbgProjectKitchenCreateRoute, element: <MBGProjectKitchenForm /> },
        { ...mbgProjectKitchenEditRoute, element: <MBGProjectKitchenForm /> },
        { ...mbgReqRoute, element: <MBGRequest /> },
        { ...mbgReqViewRoute, element: <MBGRequestView /> },
        { ...mbgFundingRoute, element: <MBGFunding /> },
        { ...mbgFundingViewRoute, element: <MBGFundingView /> },
        { ...mbgSupplierRoute, element: <MBGSupplier /> },
        { ...mbgSupplierCreateRoute, element: <MBGSupplierFrom /> },
        { ...mbgSupplierEditRoute, element: <MBGSupplierFrom /> },
        { ...mbgSupplierSKURoute, element: <MBGSupplierSKU /> },
        { ...mbgNotifPriceRoute, element: <MBGNotifPrice /> },
    ]
}]
